import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, target, unit, icon, trend, trendValue, progressColor }) => {
  const progress = target ? (parseFloat(value) / parseFloat(target)) * 100 : 0;
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  const getProgressColorClass = () => {
    if (progressColor) return progressColor;
    if (clampedProgress >= 90) return 'bg-success';
    if (clampedProgress >= 70) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-sm border border-border h-full">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-xs md:text-sm text-muted-foreground mb-1 md:mb-2">{title}</p>
          <div className="flex items-baseline gap-2">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
              {value}
              <span className="text-base md:text-lg lg:text-xl text-muted-foreground ml-1">{unit}</span>
            </h3>
          </div>
          {target && (
            <p className="text-xs md:text-sm text-muted-foreground mt-1">
              Target: {target}{unit}
            </p>
          )}
        </div>
        <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name={icon} size={20} color="var(--color-primary)" className="md:w-6 md:h-6" />
        </div>
      </div>
      {target && (
        <div className="space-y-2">
          <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
            <div
              className={`h-full ${getProgressColorClass()} transition-all duration-500`}
              style={{ width: `${clampedProgress}%` }}
            />
          </div>
          <div className="flex items-center justify-between text-xs md:text-sm">
            <span className="text-muted-foreground">{clampedProgress?.toFixed(1)}% of target</span>
            {trend && (
              <span className={`flex items-center gap-1 ${trend === 'up' ? 'text-success' : 'text-error'}`}>
                <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
                {trendValue}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MetricCard;